import script from "./ScreenHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenHome.vue?vue&type=script&setup=true&lang=js"

import "./ScreenHome.vue?vue&type=style&index=0&id=74e185cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e185cb"]])

export default __exports__